import { inject, reactive, ref, provide, computed} from 'vue';

import Card from '@/components/content/views/card/card.vue';
import FormattingService from '@/services/formatting.service';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@/components/content/views/tooltip/tooltip.vue';
import SkeletonLoader from '@/components/content/views/skeleton-loader/skeleton-loader.vue';

library.add(faInfo);

export default {
  name: 'Webcast',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    }
  },
  components: {
    FontAwesomeIcon,
    Card,
    Tooltip,
    SkeletonLoader,
  },
  setup(props) {
    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      imageUrl: computed(() => {
        if(!state.item.images) return '';
        if(state.item.images['480w']) return state.item.images['480w'];
        if(state.item.images['320w']) return state.item.images['320w'];
        if(state.item.images['600w']) return state.item.images['600w'];
        if(state.item.images['768w']) return state.item.images['768w'];
        return state.item.images.full;
      })
    });

    return {
      state,
      FormattingService,
    }
  },
  methods: {
    toggleModal(item) {
      this.$emit('toggleModal', item);
    }
  }
}
